import React from 'react';

const CTAButton = ({ href, children, variant = 'primary', className = '', target, rel }) => {
  const buttonClass = variant === 'secondary' ? 'btn-secondary' : 'btn-primary';

  return (
    <a href={href} className={`${buttonClass} ${className}`.trim()} target={target} rel={rel}>
      {children}
    </a>
  );
};

export default CTAButton;
